import {
    Component,Injectable, EventEmitter, Inject, Output, Input, NgModule, ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DewService } from "../services/dew.service";
import { MainService } from "../services/main.services";
import { ApiService } from "../services/api.services";
import * as _ from "lodash";
import { Config } from "../config";
import { config } from "rxjs";
import { query } from "@angular/animations";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DewAuthService } from "src/authentication/core/auth.service";


declare const fabric: any;

@Component({
    selector: "pdfViewer",
    templateUrl: "pdfViewer.dialog.html",
    styleUrls: []
})
export class pdfViewerDialogComponent {
    
    pdfUrl;
    ImageName;
    url;

    pagecanvas = [];
    fabriccanvas = [];
    fabriccanvaslower = [];
    fabricupperlayer = [];
    page = 1;
    zoom = 1.0;

  private canvas: any;
  private selected: any;
    constructor(
        private dialogRef: MatDialogRef<pdfViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private route: Router,
        private dewService: DewService,
        private mainService: MainService,
        private authService: DewAuthService,
        private api: ApiService,
        private snackBar: MatSnackBar

    ) {
        this.url = Config.DocumentBaseUrl;
        this.pdfUrl = this.url + data.docUrl;
        // console.log(this.pdfUrl );
        
        // this.ImageName = data.documentName;
    }

    ngOnInit() {
    }

    incrementPage(amount: number) {
        const pages = document.getElementsByTagName("canvas");
        this.pagecanvas[
          parseInt(this.page.toString(), 0) - 1
        ] = pages[0] as HTMLCanvasElement;
        this.fabriccanvaslower[
          parseInt(this.page.toString(), 0) - 1
        ] = pages[1] as HTMLCanvasElement;
        this.page += amount;
    }
    
      incrementZoom(amount: number) {
        this.zoom += amount;
        setTimeout(() => {
          this.Zoomfabric();
        }, 500);
      }
    
      Zoomfabric() {
        var pageid = parseInt(this.page.toString(), 0);
        var wrapper = document.getElementsByClassName("canvasWrapper");
        var canvas = this.fabriccanvaslower[parseInt(this.page.toString(), 0) - 1];
        var canvasContainer = document.createElement("div"); // Create with DOM
        canvasContainer.setAttribute("class", "canvas-container");
        canvasContainer.setAttribute(
          "style",
          "width: " +
          parseInt($("#page" + pageid).css("width"), 0) +
          "px; height: " +
          parseInt($("#page" + pageid).css("height"), 0) +
          "px; position: absolute; user-select: none; top: 0px; left: 0px;"
        );
    
        for (var i = 0; i < wrapper.length; i++) {
          canvas.height = parseInt($("#page" + pageid).css("height"), 0);
          canvas.width = parseInt($("#page" + pageid).css("width"), 0);
          wrapper[i].appendChild(canvasContainer);
          canvasContainer.appendChild(canvas);
        }
    
        // this.fabriccanvas[(parseInt(this.page.toString(), 0) - 1)] = new fabric.Canvas('pageCanvasOverlay' + pageid, {
        //   hoverCursor: 'pointer',
        //   selection: true,
        //   selectionBorderColor: 'blue',
        // });
        canvasContainer.appendChild(
          this.fabricupperlayer[parseInt(this.page.toString(), 0) - 1]
        );
        this.canvas = this.fabriccanvas[parseInt(this.page.toString(), 0) - 1];
        $(canvas)
          .parent()
          .css("position", "absolute")
          .css("top", "0")
          .css("left", "0");
        this.canvas.on({
          "object:moving": e => {
            // console.log(JSON.stringify(e));
          },
          "object:modified": e => { },
          "object:selected": e => {
            let selectedObject = e.target;
            this.selected = selectedObject;
            selectedObject.hasRotatingPoint = true;
            selectedObject.transparentCorners = false;
            if (selectedObject.type !== "group" && selectedObject) {
              switch (selectedObject.type) {
                case "image":
                  // console.log("image");
                  break;
              }
            }
          }
        });
      }

      download(){
        window.location.assign(this.pdfUrl);
      }

      
    close() {
        this.dialogRef.close();
    }



    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
    }
}
